import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'

export default defineNuxtRouteMiddleware((to) => {
	if (to.query.testing !== '123') {
		return navigateTo('/')
	}
})
